// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { authApi } from './services/authApi';
import { faqApi } from './services/faqApi';
import { settingsApi } from './services/settingsApi';
import { clientApi } from './services/clientApi';
import { stopWordsApi } from './services/stopWordsApi';
import { usersApi } from './services/usersApi';
import { accountsApi } from './services/accountsApi';
import { agentsApi } from './services/agentsApi';
import { chatwootTeamsApi } from './services/chatwootTeamsApi';
import { historyApi } from './services/historyApi';

// Configure persist
const persistConfig = {
  key: 'root',
  storage,
};

// Persisted Reducer
const persistedAuthReducer = persistReducer(persistConfig, authApi.reducer);

// Enable Redux DevTools
const store = configureStore({
  reducer: {
    [authApi.reducerPath]: persistedAuthReducer,
    [faqApi.reducerPath]: faqApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [clientApi.reducerPath]: clientApi.reducer,
    [stopWordsApi.reducerPath]: stopWordsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
    [agentsApi.reducerPath]: agentsApi.reducer,
    [chatwootTeamsApi.reducerPath]: chatwootTeamsApi.reducer,
    [historyApi.reducerPath]: historyApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(
      authApi.middleware,
      faqApi.middleware,
      settingsApi.middleware,
      clientApi.middleware,
      stopWordsApi.middleware,
      usersApi.middleware,
      accountsApi.middleware,
      agentsApi.middleware,
      chatwootTeamsApi.middleware,
      historyApi.middleware
    ),
  devTools: true  // Make sure DevTools is enabled
});

// Export both store and persistor
export const persistor = persistStore(store);
export default store;

